import React from 'react';
import './Navigation.scss';
import gear from 'images/gear.svg';
import adminPanel from 'images/adminPanel.svg';
import FilterAlertedFlightsToggle from 'components/FilterAlertedFlightsToggle';
import { useAuth } from 'services/authentication';
import { Link } from 'react-router-dom';

interface NavigationProps {
    dashboardId: string | null;
    filterAlertedFlights: boolean;
    onToggleFilterAlertedFlights: () => void;
}

export default function Navigation(props: NavigationProps) {
    const { user } = useAuth();

    return (
        <nav className="navigation" data-testid="navigation">
            <ul>
                {!!user?.avatar && (
                    <li>
                        <img
                            className="navigation__avatar"
                            src={user?.avatar}
                            alt="Your current avatar"
                            title={`Logged in as ${user?.username}`}
                        />
                    </li>
                )}
                {user?.permissions.role === 'admin' && (
                    <li>
                        <Link title="Open admin panel" to={'/admin'}>
                            <img className="navigation__admin-panel" src={adminPanel} alt="Shield with user icon" />
                        </Link>
                    </li>
                )}
                {props.dashboardId && (
                    <li>
                        <Link title="Open dashboard settings" to={`/dashboards/${props.dashboardId}/edit`}>
                            <img className="navigation__gear" src={gear} alt="Your current avatar" />
                        </Link>
                    </li>
                )}
                {props.dashboardId && (
                    <li>
                        <FilterAlertedFlightsToggle
                            filterAlertedFlights={props.filterAlertedFlights}
                            onToggleFilterAlertedFlights={props.onToggleFilterAlertedFlights}
                        />
                    </li>
                )}
            </ul>
        </nav>
    );
}
